export const popoverWrapperStyles = {
  popover: {
    '& .MuiPopover-paper': {
      marginTop: '8px',
      boxShadow: '1px 2px 2px 0px #23252F0A, 0px 4px 10px 0px #23252F1A',
      borderRadius: '12px !important',
    },
  },
};
